import { Deserializable } from '../interfaces';

export class Gallery implements Deserializable {
  idFile: number;
  idTarjeta: number;
  urlFile: string;
  empresa: any;
  play: boolean;
  temporary: 'image' | 'video' | null;
  file: File;

  constructor() {
    this.idFile = 0;
    this.idTarjeta = 0;
    this.urlFile = '';
    this.play = false;
    this.temporary = null;
    this.file = {} as File;
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
